// src/components/WhyUs/WhyUs.js
import React from 'react';
import './WhyUs.css';

function WhyUs() {
  return (
    <section className="why-us-section">
      <div className="container">
        
        {/* Üst Kısım: Başlık ve Açıklama Yan Yana */}
        <div className="why-us-header">
          <h2 className="why-us-main-title">
            Güçlü Yönlerimiz,<br/> Sizin <span className="gold-text">Avantajınız</span>
          </h2>
          <p className="why-us-main-desc">
            Av. Emre Uygun Hukuk ve Danışmanlık Bürosu olarak, her hukuki süreci yalnızca bir dosya değil, müvekkillerimizin uzun vadeli çıkarlarının bir parçası olarak ele alıyoruz. Mevzuata hakimiyet, stratejik bakış açısı ve şeffaf iletişim anlayışıyla; bireysel ve kurumsal müvekkillerimize güvenilir, sürdürülebilir ve sonuç odaklı hukuki çözümler sunuyoruz.
          </p>
        </div>

        {/* Alt Kısım: 3'lü Renkli Kart Izgarası */}
        <div className="why-us-grid">
          
          {/* Kart 1: Koyu Gri (Mat) */}
          <div className="why-card card-dark">
            <span className="card-subtitle">Kurumsal Hukuk Yaklaşımı</span>
            <h3 className="why-card-title">Hukuki<br/>Yaklaşımımız</h3>
            <hr className="card-divider" />
            <p className="why-card-desc">
              Hukuki süreçleri, güncel mevzuat ve içtihatlar doğrultusunda titizlikle değerlendirerek müvekkillerimize güvenilir çözümler sunarız.
            </p>
          </div>

          {/* Kart 2: Gold / Altın (Öne Çıkan) */}
          <div className="why-card card-gold">
            <span className="card-subtitle">Stratejik Hukuki Çözümler</span>
            <h3 className="why-card-title">Çalışma<br/>Yaklaşımımız</h3>
            <hr className="card-divider" />
            <p className="why-card-desc">
              Her dosya, müvekkilin ihtiyaçları ve hukuki hedefleri doğrultusunda detaylı şekilde ele alınır ve stratejik bir bakış açısıyla yönetilir.
            </p>
          </div>

          {/* Kart 3: Zifiri Siyah */}
          <div className="why-card card-black">
            <span className="card-subtitle">Yenilikçi ve Etkin Hizmet</span>
            <h3 className="why-card-title">Bizi Farklı<br/>Kılan</h3>
            <hr className="card-divider" />
            <p className="why-card-desc">
              Etik değerlere bağlı, şeffaf iletişimi esas alan ve sonuç odaklı hizmet anlayışımız ile müvekkillerimizin yanında yer alırız.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}

export default WhyUs;